import { TStatusTab, ISortOption } from './types';

export type TTrendCardKPIConfigItem = {
  /** record 上 KPIValue 的字段名（默认 CreativeTrends 字段，UGC 等扩展页可注入 API 字段名） */
  dataKey: string;
  labelKey: string;
  decimal?: number;
};

/**
 * 排序选项
 * Impressions 默认 desc，可扩展为 Creatives / Avg.Days Active
 */
export const SORT_OPTIONS: ISortOption[] = [
  { value: 'impressions', text: 'Impressions', textCn: '曝光量', order: 'desc' },
  { value: 'creatives', text: 'Ads-1', textCn: '素材数', order: 'desc' },
  { value: 'avg_days_active', text: 'Avg. Days Active', textCn: '平均活跃天数', order: 'desc' },
];

/**
 * StatusTab 定义
 */
export const STATUS_TAB_OPTIONS: {
  value: TStatusTab;
  text: string;
  textCn: string;
  tips: { en: string; zh: string; };
}[] = [
  {
    value: 'hot',
    text: 'Hot',
    textCn: '热门',
    tips: {
      en: 'Trends with highest overall impressions in the selected period',
      zh: '所选时段内整体曝光量最高的趋势',
    },
  },
  {
    value: 'rising',
    text: 'Rising',
    textCn: '上升',
    tips: {
      en: 'Trends with the fastest growing impressions recently',
      zh: '近期曝光增速最快的趋势',
    },
  },
  {
    value: 'new',
    text: 'New',
    textCn: '新兴',
    tips: {
      en: 'Newly discovered trends that appeared recently',
      zh: '近期新出现的趋势',
    },
  },
];

/**
 * 标签颜色映射（用于 Type & Elements 标签 Chips）
 */
export const TAG_COLOR_MAP: Record<string, string> = {
  gameplay: '#3370FF',
  narrative: '#7C3AED',
  visual: '#059669',
  audio: '#D97706',
  emotion: '#DC2626',
  promotion: '#0891B2',
  default: '#6B7280',
};

/**
 * 列表页 Header 提示文案
 */
export const HEADER_TIPS = {
  en: 'Discover trending creative themes in gaming advertisements. Data is refreshed daily.',
  zh: '发现游戏广告中的热门创意趋势主题。数据每日更新。',
};

export const TREND_CARD_KPI_CONFIGS: TTrendCardKPIConfigItem[] = [
  {
    dataKey: 'cumulative_impressions',
    labelKey: 'Impressions',
  },
  {
    dataKey: 'creatives',
    labelKey: 'Ads-1',
  },
  {
    dataKey: 'avg_days_active',
    labelKey: 'Avg. Days Active',
    decimal: 1,
  },
];

/**
 * Drawer 中 Related Creatives 展示数量（请求 page_size=8）
 */
export const DRAWER_RELATED_CREATIVES_COUNT = 8;

/**
 * 默认分页配置
 */
export const DEFAULT_PAGE_INFO = { page: 1, page_size: 20 };

/**
 * 详情页素材区域使用的筛选器 keys（复用 CompetitorsAdCreatives）
 */
export const CREATIVE_FILTER_KEYS = [
  'ADCountryRegion',
  'ADChannel',
  'ADType',
  'ADPlatform',
  'ADImpressions',
  'ADActiveDays',
  'ADFirstSeenDateSelect',
  'ADLastSeenDateSelect',
] as const;
